import { useEffect, useState } from 'react';
import { Themes } from './config';

export type ForumThemeMode = 'light' | 'dark';
export const themeChangedEvent = 'triad-theme-changed';

// Arya, Luna and Vela are the dark families without "dark" in their names.
export function forumThemeMode(theme: string): ForumThemeMode {
    return /(^arya-|^luna-|^vela-|(?:^|-)dark(?:-|$))/.test(theme) ? 'dark' : 'light';
}

export function storedForumThemeMode(): ForumThemeMode {
    try {
        const selected = localStorage.getItem('selected-theme');
        return forumThemeMode(Themes.find(theme => theme.value === selected)?.value || 'lara-light-blue');
    }
    catch { return 'light'; }
}

export function forumThemeUrl(url: string, mode: ForumThemeMode): string {
    try {
        const target = new URL(url, window.location.href);
        if (!['https:', 'http:'].includes(target.protocol)) return url;
        target.searchParams.set('triad_theme', mode);
        return target.href;
    } catch { return url; }
}

export function useForumThemeMode(): ForumThemeMode {
    const [mode, setMode] = useState<ForumThemeMode>(storedForumThemeMode);
    useEffect(() => {
        const update = () => setMode(storedForumThemeMode());
        window.addEventListener(themeChangedEvent, update);
        window.addEventListener('storage', update);
        update();
        return () => {
            window.removeEventListener(themeChangedEvent, update);
            window.removeEventListener('storage', update);
        };
    }, []);
    return mode;
}
